module.exports = __webpack_public_path__ + "img/index_icon04.649e1208.png";